import http from "../../httpService";
import { apiUrl } from "../../../../config.js";
const apiEndpoint = apiUrl + "/inventory/procurement/procurement-report/";

export function getProcurementDashboard(fiscalYearID = 0, fiscalPeriodID = 0) {
  return http.get(
    apiEndpoint + "procurement-dashboard/" + fiscalYearID + "/" + fiscalPeriodID
  );
}

export function getPurchaseOrderSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "purchase-order-summary/" + fiscalYearID);
}

export function getLeadTimeSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "lead-time-summary/" + fiscalYearID);
}

export function getTopVendorsSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-vendors-summary/" + fiscalPeriodID);
}

export function getTopPurchaseItemsSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-purchase-items-summary/" + fiscalPeriodID);
}

export function getTopSpendAreasSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-spend-areas-summary/" + fiscalPeriodID);
}

export function getCostSavingsSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "cost-savings-summary/" + fiscalYearID);
}

export function getVendorAveragePerformanceSummary(fiscalYearID = 0) {
  return http.get(
    apiEndpoint + "vendor-average-performance-summary/" + fiscalYearID
  );
}

export function getPurchaseOverviewReport() {
  return http.get(apiEndpoint + "purchase-overview-report");
}

export function getVendorAnalyticsReport() {
  return http.get(apiEndpoint + "vendor-analytics-report");
}

export function getCostControlReport() {
  return http.get(apiEndpoint + "cost-control-report");
}
